export const levelName = 'Insel 1: Maluaki';
export const ground = [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1],
    [0,0,0,0,0,0,0,0,0,0,0,1,1,2,2,1,1,1,1,1],
    [0,0,0,0,0,0,0,0,0,0,1,1,1,2,2,1,1,1,1,1],
    [0,0,0,0,0,0,0,1,1,1,1,1,1,2,2,2,2,2,1,1],
    [0,0,0,1,1,1,1,1,1,1,1,1,1,2,2,2,2,2,1,1],
    [0,0,1,1,1,1,2,2,2,2,2,1,1,2,2,2,2,2,1,1],
    [0,0,1,1,1,1,2,2,2,2,2,2,1,2,2,2,2,1,1,0],
    [0,0,0,1,1,1,1,2,2,2,2,2,1,1,1,1,1,1,0,0],
    [0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0],
    [0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
];
export const objects = [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,2,6,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,4,6,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,6,6,0,0,6,0,0,0,0],
    [0,0,0,0,0,0,0,5,4,4,6,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
];

export const initalPushyPosition = [5,7];
